import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';
import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import CommentsFilterable from './CommentsFilterable';

const CommentsPage = () => {
    const projectId = useSelector((state: IState) => state.global.activeProject!.id);
    const profileId = useSelector((state: IState) => state.global.activeProfile!.id);

    return (
        <div className="fit-height">
            <SimplePageTitle title={t`Messages`} />

            <CommentsFilterable profileId={profileId} projectId={projectId} />
        </div>
    );
};

export default CommentsPage;
